var $77f075bb86ad7091$exports = {};
$77f075bb86ad7091$exports = {
  "buttonLabel": "Mostra suggerimenti",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " opzione disponibile");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " opzioni disponibili");
      }
    }), ".");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Ingresso nel gruppo ".concat(args.groupTitle, ", con ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " opzione");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " opzioni");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", selezionato",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Suggerimenti",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", selezionato");
  }
};
export { $77f075bb86ad7091$exports as default };